import './polyfills/from';



// WEBPACK FOOTER //
// ../work/src/js/head.js